import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const DepartmentDetails = () => {
  const { name } = useParams();
  const [department, setDepartment] = useState(null);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.get(`/api/departments/getDepartment?department=${name}`);
        setDepartment(response.data);
      } catch (err) {
        console.error('Error fetching department:', err);
      }
    };

    fetchDepartment();
  }, [name]);

  if (!department) return <p>Loading...</p>;

  return (
    <div>
      <h1>{department.department}</h1>
      <p>{department.vision}</p>
      <p>{department.mission}</p>
      <p>{department.about}</p>
      <h2>HOD</h2>
      <p>{department.hodDetails.name}</p>
      <img src={`/${department.hodDetails.photo}`} alt="HOD" />
      {/* Additional details */}
    </div>
  );
};

export default DepartmentDetails;
